import * as React from 'react';
import { StyledAppInfo, AppInfoTitle, AppInfoValue } from './styles';

export interface AppInfoProps {
	title: string;
	value: string;
}

export class AppInfo extends React.Component<AppInfoProps, {}> {

	constructor(props: AppInfoProps) {
		super(props);
	}

	render() {
		const {title, value} = this.props;
		return (
			<StyledAppInfo>
				<AppInfoTitle>{title}</AppInfoTitle>
				<AppInfoValue>{value}</AppInfoValue>
			</StyledAppInfo>
		);
	}
}

export default AppInfo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/AppInfo/index.tsx